import { render, staticRenderFns } from "./re-fabric-canvas.vue?vue&type=template&id=1652c1f8"
import script from "./re-fabric-canvas.vue?vue&type=script&lang=ts"
export * from "./re-fabric-canvas.vue?vue&type=script&lang=ts"
import style0 from "./re-fabric-canvas.vue?vue&type=style&index=0&id=1652c1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports